import React, { useState, useEffect } from "react"
import { Typography, Collapse, FormControlLabel, Switch, Popover, TextField, Tooltip } from '@mui/material';
import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import { Row, Col, message as AntdMessage } from "antd"
import { MoreHoriz, Info } from '@mui/icons-material';
import moment from "moment"
import Loading from "components/Loading";
import { isEmpty, get } from 'lodash'
import { useChatConfig } from 'store/chat/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useDispatch } from "react-redux"
import { handleUpdateUserChatHour, handleUpdateUserChatSeen, handleUpdateUNotificationConfig , handleUpdateUserChatDiable} from "store/chat/thunks";
import * as Sentry from '@sentry/react';
const time_format = "HH:mm";


const SettingContainer = styled.div`
    background-color: #fff;
    width: 300px;
    min-height:100px;
    padding: 20px;
    position:relative;
    display: flex;
    flex-direction: column;
    min-height:100px;
    border-radius: 6px;
`;
const RowChatHourSwitch = styled.div`
   display:flex;
   flex-direction:row;
   width: 100%;
   justify-content: space-between;

`;
const HrUpdateButton = styled.button`
    color: #fff;
    border-radius: 10px;
    outline: none;
    border: none;
    padding: 2px;
    font-size: 12px;
    width: 70px;
    background: rgb(80,114,116);
    cursor: pointer;
`;

const IOSSwitch = muiStyled(Switch)(({ theme }) => ({
    width: 42,
    height: 25,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        transform: 'translateX(0px)',
        color: '#f44336',
        '&.Mui-checked': {
            color: '#4caf50 !important',
            transform: 'translateX(16px)',
            '& .MuiSwitch-thumb:before': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                    '#fff',
                )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
            },
            '& + .MuiSwitch-track': {
                backgroundColor: 'rgb(52,51,74)',
                opacity: 1,
                border: 0,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 16,
        height: 16,
        marginTop: 3,
        marginRight: 0,
        marginLeft: 4.5,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: 'rgb(52,51,74)',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
    '&.MuiSwitch-root .MuiSwitch-switchBase.Mui-checked': {
        color: '#4caf50 !important',
    },
    '&.MuiSwitch-root .MuiSwitch-switchBase': {
        color: '#f44336 !important',
    },
}));

export const Settings = ({ setAlertView, socket }) => {
    const userChatConfig = useChatConfig()
    const [chatHour, setChatHour] = useState(null)
    const [messageSeen, setMessageSeen] = useState(false)
    const [notification, setNotification] = useState(false)
    const [settingEl, setSettingEl] = React.useState(null);
    const [chatHourSwitch, setChatHourSwitch] = useState(false)
    const dispatch = useDispatch()
    const settingPopOveropen = Boolean(settingEl);
    const settingPopOverid = settingPopOveropen ? 'simple-popover' : undefined;
    const currentUser = useCurrentUser()
    const isStudent = get(currentUser, "role") === "student";
    const [hrUpdateLoader, sethrUpdateLoader] = useState(false)
    const [chatDisabled,setChatDisabled] = useState(false)
    useEffect(() => {
        if(!isEmpty(userChatConfig)){
            setChatHourSwitch(!!get(userChatConfig, "chatHour"))
            setChatDisabled(get(userChatConfig, "disabled",false))
            setChatHour(get(userChatConfig, "chatHour"))
            setMessageSeen(get(userChatConfig, "messageSeen", true))
            setNotification(get(userChatConfig, "notification", true))
        }
    }, [userChatConfig])
    const updateChatHourConfig = async (cHour,isTurnOff) => {
        if(get(userChatConfig, "chatHour")==cHour) {
            setChatHourSwitch(!!cHour)
            return;
        }
        sethrUpdateLoader(true)
        if (!isTurnOff) {
            if (!cHour || !cHour.endTime || !cHour.startTime) {
                setAlertView({ open: true, message: "Plese set time first." })
                sethrUpdateLoader(false)
                return;
            }
            if (moment(cHour.endTime, time_format).isSameOrBefore(moment(cHour.startTime, time_format), "hours")) {
                setAlertView({ open: true, message: "End time has to  be after start time." })
                sethrUpdateLoader(false)
                return;
            }

        }
        const config = await dispatch(handleUpdateUserChatHour(currentUser.id, cHour))
        if (socket) {
            try {
                socket.send(JSON.stringify({ type: "config_update", code: 'config_update', config: config, id: currentUser.id }))
            } catch (error) {
                console.log(error, "socket send update error")
                Sentry.captureException(`451 Error during updateChatHourConfig: ${error}`);
            }
        }
        sethrUpdateLoader(false)
    }
    const updateMessageSeenConfig = async (seenVal) => {
        AntdMessage.loading("Updating message seen config...")
        const config = await dispatch(handleUpdateUserChatSeen(currentUser.id, typeof seenVal == "boolean" ? seenVal : messageSeen))
        if (seenVal) {
            AntdMessage.success("Message seen enabled on student view")
        } else {
            AntdMessage.warning("Message seen disabled on student view")
        }
        if (socket) {
            try {
                socket.send(JSON.stringify({ type: "config_update", code: 'config_update', config: config, id: currentUser.id }))
            } catch (error) {
                console.log(error, "socket send update error")
                Sentry.captureException(`452 Error during updateMessageSeenConfig: ${error}`);
            }
        }
    }
    const updateDiabledConfig = async (diableValue) => {
        const config = await dispatch(handleUpdateUserChatDiable(currentUser.id, typeof diableValue == "boolean" ? diableValue : chatDisabled))
        if (socket) {
            try {
                socket.send(JSON.stringify({ type: "config_update", code: 'config_update', config: config, id: currentUser.id }))
            } catch (error) {
                console.log(error, "socket send update error")
                Sentry.captureException(`453 Error during updateDiabledConfig: ${error}`);
            }
        }
    }
    const updateNotificationConfig = async (val) => {
        await dispatch(handleUpdateUNotificationConfig(currentUser.id, typeof val == "boolean" ? val : notification))
    }
    const onChatHourChange = (time, type) => {
        let cHour = { ...chatHour }
        if (type == "startTime") {
            const startTimeTemp = moment(time, time_format)
            if (cHour.endTime) {
                const lastEndTime = moment(cHour.endTime, time_format)
                if (lastEndTime.isSameOrAfter(startTimeTemp, "hours") && lastEndTime.isSameOrAfter(startTimeTemp, "minutes")) {
                    cHour.startTime = startTimeTemp.format(time_format);
                } else {
                    setAlertView({ open: true, message: "Start time has to be before end time." })
                }

            } else {
                cHour.startTime = startTimeTemp.format(time_format);
            }

        } else {
            const endTimeTemp = moment(time, time_format)
            if (cHour.startTime) {
                const lastEndTime = moment(cHour.startTime, time_format)
                if (lastEndTime.isSameOrBefore(endTimeTemp, "hours") && lastEndTime.isSameOrBefore(endTimeTemp, "minutes")) {
                    cHour.endTime = endTimeTemp.format(time_format);
                } else {
                    setAlertView({ open: true, message: "End time has to  be after start time." })
                }
            } else {
                cHour.endTime = endTimeTemp.format(time_format);
            }
        }
        setChatHour(cHour)
    }
    const onClickSettingClick = (event) => {
        setSettingEl(event.currentTarget);
    };

    const onSettingClose = () => {
        setSettingEl(null);
    };
    return (
        <>
            {!isStudent&&<MoreHoriz className="moreMenuOptn" aria-describedby={settingPopOverid} onClick={onClickSettingClick} />}
            <Popover 
                style={{
                    background: 'transparent',
                    bordeRadius: '20px'
                }}
                id={settingPopOverid}
                open={settingPopOveropen}
                anchorEl={settingEl}
                className={"chatSettingPopOver"}
                onClose={onSettingClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}>

                <SettingContainer className="messagesBoxSet">
                    {!isStudent ? <> <RowChatHourSwitch className="messagesBoxSwthr">
                        <Typography style={{
                            color: 'black',
                            fontSize: '13px',
                            fontWeight: '500'
                        }} variant="subtitle2">My Chat Hours</Typography>
                        <FormControlLabel
                            control={<IOSSwitch disabled={hrUpdateLoader} checked={chatHourSwitch} onChange={e => {
                                if (hrUpdateLoader) return;
                                if (e.target.checked) {
                                    setChatHour({
                                        startTime: null,
                                        endTime: null
                                    })
                                    setChatHourSwitch(true)
                                } else {
                                    setChatHour(null)
                                    updateChatHourConfig(null,true)
                                }
                            }} name="checkedB" />}
                        />
                    </RowChatHourSwitch>
                        <Collapse className="messagesBoxColap" in={chatHourSwitch} style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <Row style={{ width: "100%", marginTop: 10 }}>
                                <Col span={12} style={{ paddingRight: 5 }}>
                                    {chatHourSwitch && <TextField
                                        id="startTime"
                                        variant="outlined"
                                        type="time"
                                        className={"schedultTimePicker"}
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                        inputProps={{
                                            step: 300, // 5 min
                                        }}
                                        value={get(chatHour, "startTime")}
                                        onChange={(e) => {
                                            onChatHourChange(e.target.value, "startTime")
                                        }}
                                    />}
                                    {/* <TimePicker placeholder='start time'
                                        inputVariant="outlined"
                                        className={"schedultTimePicker"}
                                        value={chatHour ? moment(get(chatHour, "startTime"), 'h:mm a') : null}
                                        onChange={e => {
                                            onChatHourChange(e, "startTime")
                                        }} /> 
                                        
                                        <TimePicker placeholder='end time'
                                        inputVariant="outlined"
                                        value={chatHour ? moment(get(chatHour, "endTime"), 'h:mm a') : null}
                                        className={"schedultTimePicker"}
                                        onChange={e => {
                                            onChatHourChange(e, "endTime")
                                        }} /> */}
                                </Col>
                                <Col span={12} style={{ paddingLeft: 5 }}>

                                    {chatHourSwitch && <TextField
                                        id="endTime"
                                        variant="outlined"
                                        type="time"
                                        className={"schedultTimePicker"}
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                        inputProps={{
                                            step: 300, // 5 min
                                        }}
                                        value={get(chatHour, "endTime")}
                                        onChange={(e) => onChatHourChange(e.target.value, "endTime")}
                                    />}
                                </Col>
                            </Row>
                            <Row style={{ width: "100%", marginTop: 10, justifyContent: "flex-end", display: "flex", flexDirection: "row" }}>
                                <HrUpdateButton onClick={() => updateChatHourConfig(chatHour)}  >{hrUpdateLoader ? <Loading white size={15} /> : "Update"}</HrUpdateButton>
                            </Row>
                        </Collapse>
                        <RowChatHourSwitch className="messagesBoxHrRut" style={{ marginTop: 10 }}>
                                <Typography style={{
                                    color: 'black',
                                    fontSize: '13px',
                                    fontWeight: '500'
                                }} variant="subtitle2">Show Read Message 
                                <Tooltip title="This will enable or disable show read message on student view">
                                    <Info style={{ fontSize: '16px', color: '#666', cursor: 'help' }} />
                                </Tooltip>
                                </Typography>
                            <FormControlLabel
                                control={<IOSSwitch checked={messageSeen} onChange={e => {
                                    updateMessageSeenConfig(e.target.checked)
                                    setMessageSeen(e.target.checked)
                                }} name="messageSeen" />}
                            />
                        </RowChatHourSwitch></> : null}
                    <RowChatHourSwitch className="messagesBoxHrRut" style={{ marginTop: 10 }}>
                        {/* <Typography style={{
                            color: 'black',
                            fontSize: '13px',
                            fontWeight: '500'
                        }} variant="subtitle2">Block Pop-Up Notifications</Typography>
                        <FormControlLabel
                            control={<IOSSwitch checked={!notification} onChange={e => {
                                updateNotificationConfig(!e.target.checked)
                                setNotification(!e.target.checked)
                            }} name="messageSeen" />}
                        /> */}
                    </RowChatHourSwitch>
                    {!isStudent ? <RowChatHourSwitch className="messagesBoxHrRut" style={{ marginTop: 10 }}>
                        <Typography style={{
                            color: 'black',
                            fontSize: '13px',
                            fontWeight: '500'
                        }} variant="subtitle2">Disable</Typography>
                        <FormControlLabel
                            control={<IOSSwitch checked={chatDisabled} onChange={e => {
                                updateDiabledConfig(e.target.checked)
                                setChatDisabled(e.target.checked)
                            }} name="chatDisable" />}
                        />
                    </RowChatHourSwitch> : null}
                </SettingContainer>
            </Popover>
        </>)
}